import * as React from 'react';

const Camera16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m9.624 2.994 1.07 1.046.3.3h3.487v8.676l-12.982-.04V4.329h3.508l.3-.289 1.069-1.036h3.248M5.756 1.5 4.387 2.835H1.5c-.83 0-1.5.667-1.5 1.494V14.46h1.5l12.99.04H16V4.33h-.01c0-.828-.67-1.495-1.5-1.495h-2.867L10.253 1.5H5.757Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 6.61c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Zm0-1.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5Z"
  }
));
Camera16.Size = 16;
Camera16.Title = "Camera";

export { Camera16 as default };
